import { defineStore } from 'pinia'
import api from '@/services/api/products'

export const useProductStore = defineStore('product', () => {
  async function getProduct(id: string): Promise<GetProductResponse> {
    return await api.getProduct(id)
  }

  return {
    getProduct
  }
})
